import {ModuleComponent} from "../../js/module-component";
import Swiper from "swiper/bundle";

// import Swiper and modules styles
export class ModSlider extends ModuleComponent{
    ready(){
        super.ready();
        this.withoutAutoplay = this.$root.data(`without-autoplay`);
        const swiperContainer = this.$root.find(`.swiper-container`).get(0);

        if(!swiperContainer) return;

        const autoplayConfig = !this.withoutAutoplay?{
            delay: 7000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false
        }:{};
        this.swiper = new Swiper(swiperContainer,{
            direction: `horizontal`,
            pagination: {
                el: this.$root.find(`.swiper-pagination`).get(0),
                pauseOnMouseEnter: true
            },
            paginationType: `bullets`,
            navigation: {
                nextEl: this.$root.find(`.swiper-button-next`).get(0),
                prevEl: this.$root.find(`.swiper-button-prev`).get(0)
            },
            autoplay: autoplayConfig,
            speed: 800,
            effect: this.$root.data(`effect`),
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            initialSlide: 0,
            loop: this.$root.find(`.swiper-slide`).length>1
        });

        if(!this.withoutAutoplay){
            this.$root.find(`.swiper`).mouseenter(() => {
                this.swiper.autoplay.stop();
            }).mouseleave(() => {
                this.swiper.autoplay.start();
            });
        }else{
            this.swiper.autoplay.stop();
        }
    }
}
